/**
 +----------------------------------------------------------
 //视频自适应大小
 +----------------------------------------------------------
 */
// function getKeyVal(src, key) {
//   var matchVidArray = src.toString().split('?')[1].toString().split('&'), vid = null;
//   for (var i2 = 0; i2 < matchVidArray.length; i2++) {
//     if (matchVidArray[i2].split('=')[0].toLowerCase() == key) {
//       vid = matchVidArray[i2].split('=')[1];
//       return vid;
//     }
//   }
//   return '';
// }

export default function (src){
  if (src.match("v.qq.com") || src.match("video.qq.com") || src.match("imgcache.qq.com")) {
    src.match(/https?:\/\/v\.qq\.com\/x\/page\/(.*?)\.html/)
    // src = '//v.qq.com/txp/iframe/player.html?vid=' + getKeyVal(src, 'vid') + '&auto=0';
    src = '//v.qq.com/txp/iframe/player.html?vid=' + RegExp.$1 + '&auto=0';
  } else if (src.match("youku.com")) {
    src.match(/https?:\/\/player.youku.com\/player.php\/sid\/(.+)\/v.swf/);
    src = RegExp.$1 ? '//player.youku.com/embed/' + RegExp.$1 : src;
  } else if (src.match(/sohu\.com(.*?)v\.swf/i)) {
    src.match(/sohu\.com(.*?)v\.swf(.*?)id=(\d+)/i);
    src = '//tv.sohu.com/upload/static/share/share_play.html#4059416_' + RegExp.$3 + '_0_2_1';
  } else if (src.match("bilibili.com")) {
    src.match(/https?:\/\/(?:www\.)?bilibili.com\/video\/av([\da-zA-Z]+)/);
    //兼容以前的b站视频链接
    if(RegExp.$1){
      src = '//player.bilibili.com/player.html?aid=' + RegExp.$1;
    }else{
      src.match(/https?:\/\/(?:www\.)?bilibili.com\/video\/([\da-zA-Z]+)/);
      src = '//player.bilibili.com/player.html?bvid=' + RegExp.$1;
    }
  }
  return src
}